export const fr = {
  hero_title1: "Partagez vos ",
  hero_title2: "Dépenses",
  hero_title3: ", vos ",
  hero_title4: "Notes",
  hero_title5: ", votre ",
  hero_title6: "Agenda",
  hero_title7: " et organisez des ",
  hero_title8: "Sondages",
  hero_desc: "Linkeven, c’est la façon la plus simple (et la plus cool) de garder le contrôle sur tes dépenses de groupe sans te prendre la tête. Tu flashes un ticket ou un écran ? Hop, notre IA repère le montant toute seule et le range au bon endroit. Que ce soit pour un voyage, une coloc, un week-end ou un événement, Linkeven remplace avantageusement des applis comme Tricount ou Splitwise pour le partage de dépenses. Résultat : tu profites du moment, nous on s’occupe des chiffres ✨",
  btn_start: "Démarrer",
  ScanTitle: "Scan intelligent des montants",
  ScanText: "Prenez une photo de votre ticket ou de l'ecran de paiement: notre IA analyse et extrait automatiquement les détails de vos dépenses en un clin d’œil.",
  ExpenseFeatureTitle: "Gestion avancée des dépenses",
  ExpenseFeatureText: "Créez des groupes, ajoutez des dépenses illimitées, répartissez les montants comme vous voulez et gardez une vue claire sur qui doit quoi.",
  NoteTitle: "Notes partagées",
  NoteText: "Un bloc-notes collaboratif intégré pour vos listes de courses, todo de voyage, numéros utiles et toutes les infos importantes.",
  SurveyTitle: "Sondages",
  SurveyText: "Créez des sondages pour choisir une date, un restaurant ou une activité, et laissez le groupe voter directement dans l’app.",
  DevisesTitle: "Multi-devises & conversion automatique",
  DevisesText: "Plus de 170 devises disponibles (dont BTC), avec conversion automatique au taux du jour pour simplifier les voyages à l’étranger.",
  StatTitle: "Statistiques",
  StatText: "Visualisez qui dépense le plus, l’équilibre des dépenses et l’évolution globale du budget du groupe.",
  whyLinkount: "Pourquoi choisir Linkeven ?",
  planetickets: "Billets d'avion",
  paidBy: "payé par ",
  me: "Moi",
  september: "septembre",
  karting: "Karting",
  boat: "Bateau",
  devise: "€",
  shoppinglist: "Liste de courses",
  chips: "Chips",
  pasta: "Pâtes",
  steak: "Steak",
  beers: "Bières",
  restaurantIdeas: "Idées restos",
  restau1: "Le petit Bistrot",
  restau2: "La table du coin",
  restau3: "Pizza Loca",
  reminder: "Rappel",
  sunscreen: "Crème solaire",
  bugspray: "Anti-moustique",
  playingcards: "Cartes de jeu",
  excursions: "Excursions",
  boatday: "Journée bateau",
  castlevisit: "Visite du chateau",
  hiking: "Randonnée en montagne",
  whichRestau: "Quel restau mardi soir ?",
  votes1: "1 vote(s)",
  votes2: "0 vote(s)",
  owes: "doit",
  to: "à",
  addExpense: "Ajouts de dépenses illimités",
  statExpense: "Statistiques des dépenses",
  addTicket: "Scan intelligent des montants",
  calculdebt: "Calcul des dettes dans toutes les devises",
  shareNote: "Partage de notes (bloc-notes collaboratif)",
  pool: "Sondages / votes internes",
  agenda: "Agenda / planning intégré",
  multiDevise: "Multi-devises",
  conversion: "Conversion automatique au taux du jour",
  Devises: "Plus de 170 devises dont BTC",
  codeRedirectTitle: "Rejoignez Linkeven",
  codeRedirectInstalled: "Si vous avez déjà l'application installée, elle va s'ouvrir automatiquement.",
  codeRedirectDownload: "Sinon, téléchargez-la directement depuis le Store.",
  codeRedirectButton: "Télécharger l'application",
};